import React from 'react';
import { Monitor, Smartphone, Maximize2, Check } from 'lucide-react';
import { DropdownMenuLabel, DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { useViewport } from '@/context/ViewportContext';

/**
 * Nested menu items to toggle viewport mode.
 * Drop these inside a shadcn DropdownMenuContent, before the logout item.
 */
export default function ViewportMenuItems() {
  const { mode, setMode } = useViewport();
  const options = [
    { key: 'auto', label: 'Auto (device default)', icon: Maximize2 },
    { key: 'desktop', label: 'Desktop view', icon: Monitor },
    { key: 'mobile', label: 'Mobile view', icon: Smartphone },
  ];
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className="text-xs uppercase tracking-wide text-muted-foreground font-medium">
        Display
      </DropdownMenuLabel>
      {options.map((opt) => {
        const Icon = opt.icon;
        const active = mode === opt.key;
        return (
          <DropdownMenuItem
            key={opt.key}
            data-testid={`viewport-${opt.key}`}
            onClick={() => setMode(opt.key)}
            className={active ? 'bg-primary/5 font-medium' : ''}
          >
            <Icon className="w-4 h-4 mr-2" />
            <span className="flex-1">{opt.label}</span>
            {active && <Check className="w-4 h-4 text-primary" />}
          </DropdownMenuItem>
        );
      })}
    </>
  );
}
